<template>
    <div class="tdtmap" v-loading="getDataLoading">
        <div ref="mapContainer" class="tdtmap-container"></div>
    </div>
</template>

<script>
import marker_house from '@/assets/img/marker_house.png';
import { getListPage } from '@/api/utils';

export default {
    name: 'TdtMap',
    props: {
        tableName: {
            type: String
        },
        apiKey: {
            type: String,
            default: '52eda5d646e55bc9ba09a7b6ec607bed'
        }
    },
    data() {
        return {
            getDataLoading: false,
            markersData: [],
            center: { lng: 113, lat: 29 },
            zoom: 6,
            map: null,
            markers: [],
            currentInfoWindow: null,
            currentMarker: null,
            destroyed: false,
            infoWindow: {
                show: false,
                info: {}
            }
        }
    },
    async mounted() {
        try {
            await this.loadTiandituScript();
            if (this.destroyed) return;
            this.initMap();
            await this.loadData();
            if (this.destroyed) return;
            this.renderMarkers();
        } catch (err) {
            console.error('TdtMap init error:', err);
        }
    },
    beforeDestroy() {
        this.destroyed = true;
        this.clearAllMarkers();
        if (this.currentMarker && this.currentInfoWindow) {
            try { this.currentMarker.closeInfoWindow(); } catch (e) {}
            this.currentMarker = null;
        }
        if (this.currentInfoWindow) {
            try { this.map.closeInfoWindow(); } catch (e) {}
            this.currentInfoWindow = null;
        }
        if (this.map) {
            try { this.map.destroy && this.map.destroy(); } catch (e) {}
            this.map = null;
        }
    },
    methods: {
        loadTiandituScript() {
            var vm = this;
            return new Promise(function (resolve, reject) {
                if (window.T) return resolve();
                var src = 'https://api.tianditu.gov.cn/api?v=4.0&tk=' + vm.apiKey;
                var s = document.createElement('script');
                s.src = src;
                s.onload = function () { resolve(); };
                s.onerror = function () { reject(new Error('加载天地图脚本失败')); };
                document.head.appendChild(s);
            });
        },
        initMap() {
            var T = window.T;
            this.map = new T.Map(this.$refs.mapContainer);
            this.map.centerAndZoom(new T.LngLat(this.center.lng, this.center.lat), this.zoom);

            var ctrl = null;
            try { ctrl = new T.Control.Zoom(); } catch (e) { }
            if (!ctrl) {
                try { ctrl = new T.ZoomControl(); } catch (e) { }
            }
            if (ctrl && this.map.addControl) {
                this.map.addControl(ctrl);
            }
        },
        async loadData() {
            this.getDataLoading = true;
            var res1data = await this.getTableData(this.tableName);
            var res2data = await this.getTableData('Equipment');
            res1data = res1data.filter(function (item) { return item.Coordinate != '' && item.Coordinate != null; });
            res2data = res2data.filter(function (item) { return item.Coordinate != '' && item.Coordinate != null; });
            this.markersData = res1data.concat(res2data);
            for (var i = 0; i < this.markersData.length; i++) {
                this.markersData[i]['Coordinate'] = this.getMarkerLngLat(this.markersData[i]);
            }
            this.center = this.autoSetMapCenter(this.markersData);
            this.getDataLoading = false;
        },
        renderMarkers() {
            if (!this.map) return;
            this.clearAllMarkers();
            var T = window.T;
            var vm = this;
            var houseIcon = null;
            try {
                houseIcon = new T.Icon({
                    iconUrl: marker_house,
                    iconSize: new T.Size(48, 48),
                    iconAnchor: new T.Size(24, 48)
                });
            } catch (e) {
                try {
                    houseIcon = new T.Icon({
                        iconUrl: marker_house,
                        iconSize: { x: 48, y: 48 },
                        iconAnchor: { x: 24, y: 48 }
                    });
                } catch (e2) {
                    houseIcon = null;
                }
            }

            for (var i = 0; i < this.markersData.length; i++) {
                var data = this.markersData[i];
                var lng = parseFloat(data.Coordinate.lng);
                var lat = parseFloat(data.Coordinate.lat);
                if (isNaN(lng) || isNaN(lat)) continue;

                var markerOpts = {};
                if (data.Code !== undefined && houseIcon) {
                    markerOpts.icon = houseIcon;
                }

                var marker = new T.Marker(new T.LngLat(lng, lat), markerOpts);

                (function (d, m) {
                    m.addEventListener('click', function () {
                        vm.lookDetail(d, m);
                    });
                })(data, marker);

                this.addOverlayToMap(marker);
                this.markers.push(marker);
            }

            if (this.markersData.length > 0 && this.map.centerAndZoom) {
                this.map.centerAndZoom(new T.LngLat(this.center.lng, this.center.lat), this.zoom);
            }
        },
        addOverlayToMap(marker) {
            if (!this.map) return;
            if (this.map.addOverLay) {
                this.map.addOverLay(marker);
            } else if (this.map.addOverlay) {
                this.map.addOverlay(marker);
            }
        },
        clearAllMarkers() {
            for (var i = 0; i < this.markers.length; i++) {
                try {
                    if (this.map.removeOverLay) {
                        this.map.removeOverLay(this.markers[i]);
                    } else if (this.map.removeOverlay) {
                        this.map.removeOverlay(this.markers[i]);
                    }
                } catch (e) { }
            }
            this.markers = [];
        },
        async getTableData(tbname) {
            var res = await getListPage(tbname, {}).catch(function () { });
            if (!res || !res.Data) return [];
            return res.Data.list || [];
        },
        autoSetMapCenter(markers) {
            var arr = markers.filter(function (item) {
                return item.Coordinate.lng != 0 && item.Coordinate.lat != 0;
            });
            if (arr.length === 0) {
                return { lng: 113, lat: 29 };
            }
            var maxLng = Math.max.apply(Math, arr.map(function (o) { return o.Coordinate.lng; }));
            var minLng = Math.min.apply(Math, arr.map(function (o) { return o.Coordinate.lng; }));
            var maxLat = Math.max.apply(Math, arr.map(function (o) { return o.Coordinate.lat; }));
            var minLat = Math.min.apply(Math, arr.map(function (o) { return o.Coordinate.lat; }));

            var zoom = this.getZoomByBounds(maxLng, minLng, maxLat, minLat);
            if (zoom) this.zoom = zoom;

            return {
                lng: (maxLng + minLng) / 2,
                lat: (maxLat + minLat) / 2
            };
        },
        getZoomByBounds(maxLng, minLng, maxLat, minLat) {
            var lngSpan = maxLng - minLng;
            var latSpan = maxLat - minLat;
            if (lngSpan <= 0 && latSpan <= 0) return null;
            var maxSpan = Math.max(lngSpan, latSpan);
            if (maxSpan > 10) return 6;
            if (maxSpan > 3) return 8;
            if (maxSpan > 1) return 10;
            if (maxSpan > 0.3) return 12;
            if (maxSpan > 0.1) return 14;
            return 15;
        },
        getMarkerLngLat(marker) {
            var markerLngLat = {
                lng: 0,
                lat: 0
            };
            if (marker.Coordinate != '' && marker.Coordinate != null) {
                var coords = marker.Coordinate.split(',');
                markerLngLat.lng = parseFloat(coords[0]);
                markerLngLat.lat = parseFloat(coords[1]);
            }
            return markerLngLat;
        },
        lookDetail(data, marker) {
            this.closeInfoWindow();

            var infoData = {};
            var type = '';
            if (data.Name != undefined) {
                infoData = {
                    '采样点名称': data.Name,
                    '地址': data.Address,
                    '所属区域': data.RegionName,
                    '负责人': data.Contractor
                };
                type = '采样点';
            }
            if (data.Code != undefined) {
                infoData = {
                    '设备编号': data.Code,
                    '地址': data.Address,
                    '负责人': data.Principal,
                    '状态': data.Status
                };
                type = '设备';
            }

            this.infoWindow.info = {
                data: infoData,
                type: type,
                lng: data.Coordinate.lng,
                lat: data.Coordinate.lat
            };
            this.infoWindow.show = true;

            this.openInfoWindow(marker, type, infoData);
        },
        openInfoWindow(marker, type, infoData) {
            var T = window.T;
            var html = '<div class="tdt-iw-wrap">';
            html += '<div class="tdt-iw-title">' + type + '</div>';
            var keys = Object.keys(infoData);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var val = infoData[key];
                html += '<p><span class="infoleft">' + key + '：</span>';
                html += '<span class="inforight">' + val + '</span></p>';
            }
            html += '</div>';

            try {
                var infoWin = new T.InfoWindow(html);
                marker.openInfoWindow(infoWin);
                this.currentInfoWindow = infoWin;
                this.currentMarker = marker;
            } catch (e) {
                try {
                    var opts = { content: html };
                    var infoWin2 = new T.InfoWindow(opts);
                    marker.openInfoWindow(infoWin2);
                    this.currentInfoWindow = infoWin2;
                    this.currentMarker = marker;
                } catch (e2) {
                    console.error('openInfoWindow error:', e2);
                }
            }
        },
        closeInfoWindow() {
            if (this.currentMarker && this.currentInfoWindow) {
                try { this.currentMarker.closeInfoWindow(); } catch (e) { }
                this.currentMarker = null;
            } else if (this.currentInfoWindow && this.map) {
                try { this.map.closeInfoWindow(); } catch (e) { }
            }
            this.currentInfoWindow = null;
            this.infoWindow.show = false;
        },
        infoWindowClose() {
            this.closeInfoWindow();
        },
        infoWindowOpen() {
            this.infoWindow.show = true;
        }
    }
}
</script>

<style>
.tdtmap {
    width: calc(100% + 20px);
    margin-left: -10px;
    margin-right: -10px;
    height: 100%;
}

.tdtmap-container {
    width: 100%;
    height: 100%;
}

.tdtmap .infoleft {
    color: #ccc;
    font-size: 13px;
}

.tdtmap .inforight {
    color: #409eff;
    font-size: 13px;
}

.tdt-iw-wrap {
    min-width: 160px;
    padding: 4px 8px;
}

.tdt-iw-wrap .tdt-iw-title {
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 6px;
    padding-bottom: 4px;
    border-bottom: 1px solid #eee;
}

.tdt-iw-wrap p {
    margin: 4px 0;
    line-height: 1.6;
}
</style>
